import { DateRangeCalendar, Popover } from '@medly-components/core';
import { useContext, useState, type FC } from 'react';
import type { FlatDateRangePickerProps } from './types';

export const DateRangePickerCalendar: FC<FlatDateRangePickerProps> = ({ value, onChange, popoverPlacement, autoSelectEndDateIn }) => {
    const [, setCalenderVisibility] = useContext(Popover.Context);
    const [currentDateElement, setCurrentDateElement] = useState<'START_DATE' | 'END_DATE'>('START_DATE');

    return (
        <DateRangeCalendar
            id="date-range-calendar"
            selectedDates={value}
            onDateSelection={onChange}
            placement={popoverPlacement}
            focusedElement={currentDateElement}
            onFocusChange={setCurrentDateElement}
            autoSelectEndDateIn={autoSelectEndDateIn}
            onClose={() => setCalenderVisibility(false)}
        />
    );
};
